import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  table: {
    // tableLayout: "fixed",
  },
  arrowUpIcon: {
    marginRight: "5px",
    position: "relative",
    top: "3px",
  },
  arrowDownIcon: {
    marginRight: "5px",
    position: "relative",
    top: "3px",
  },
  arrowRightIcon: {
    marginRight: "5px",
    position: "relative",
    top: "3px",
  },
  tableHeader: {
    fontSize: 14,
    fontWeight: 500,
    padding: "16px"
  },
  bgWhite: {
    backgroundColor: "rgba(255, 255, 255, 1)",
  },
  bgGray: {
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
  sortArrow: {
    position: "relative",
    top: "7px",
    cursor: "pointer",
    color: "#8291A9",
  },
  praisoTablePagination: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: theme.spacing(5),
  },
  lengthDropdown: {
    marginLeft: theme.spacing(2),
    border: 0,
    backgroundColor: "transparent",
    "& .MuiSelect-root": {
      marginTop: 5,
    },
  },
  pageCounter: {
    margin: theme.spacing(0.25, 3, 0),
  },
  avatarContainer: {
    position: "relative",
    display: "inline-flex",
    justifyContent: "center",
  },
  star: {
    fontSize: 30,
    color: theme.palette.primary.main,
    position: "absolute",
    left: "50%",
    top: 25,
    transform: "translate(-50%, 0)",
  },
  avatar: {
    "&, &.MuiAvatar-root": {
      backgroundColor: alpha(theme.palette.primary.main, 0.5),
      color: "#000",
      fontSize: ".85rem",
      fontWeight: 500,
    },
  },
  expandedRow: {
    backgroundColor: "rgb(246,248,249)",
    boxShadow: "0 -1px 2px 1px rgb(0 0 0 / 10%)",
  },
  expandedRowCell: {
    position: "relative",
    borderBottom: "1px solid rgba(224, 224, 224, 0.4)!important",
    padding: 0,
  },
  cellCursor: {
    cursor: "pointer",
  },
  cellTrend: {
    width: "50px"
  },
  tableCellValue: {
    fontWeight: 500,
    color: '#242A38',
    padding: theme.spacing(0.5, 1),
    fontSize: 14,
    "& a": {
      color: "rgba(0, 0, 0, 0.87)",
      textDecoration: "unset",
    },
  },
  eventDateValue: {
    fontWeight: 300,
    color: "rgba(0, 0, 0, 1)",
    fontSize: 13,
    margin: '0px -10px',
  },
  eventTimeValue: {
    fontWeight: 300,
    color: "rgba(0, 0, 0, 1)",
    fontSize: 13,
    margin: '0px -10px',
  },
  search: {
    marginLeft: "auto",
    marginBottom: theme.spacing(2),
    "& .MuiInputBase-root": {
      maxWidth: '100%',
      padding: 10,
      borderRadius: 30,
      border: "unset",
      position: "relative",
      marginRight: 0,
      paddingLeft: 20,
      border: "1px solid #fff",
      transition: "border 0.4s ease-in-out",
      "&:hover, &:focus": {
        boxShadow: "2px 2px 9px 2px rgba(0,0,0,0.1)",
      },
      [theme.breakpoints.up("md")]: {
        // width: 300,
      },
    },
    "& .MuiInputBase-root::before": {
      content: "unset",
    },
    "& .MuiInputBase-root::after": {
      content: "unset",
    },
    "& .MuiFormLabel-root": {
      paddingLeft: 10,
      color: "#AEB2BA",
      position: "relative",
      zIndex: 2,
      top: 20,
      left: 10,
    },
    "& .MuiFormLabel-root.Mui-focused": {
      paddingLeft: 10,
      color: theme.palette.primary.main,
      position: "relative",
      zIndex: 2,
      top: 0,
      left: 0,
    },
    "& .MuiFormLabel-root.MuiFormLabel-filled": {
      paddingLeft: 10,
      color: theme.palette.primary.main,
      position: "relative",
      zIndex: 2,
      top: 0,
      left: 0,
    },
    "& + *": {
      marginLeft: 16,
    },
  },
  eventDropDown: {
    marginLeft: "auto",
    width: "200pt",
    height: "48pt",
    // marginBottom: theme.spacing(2),
    "& .MuiSelect-icon": {
      marginRight: "10px",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "unset",
    },
    "& .MuiInputBase-root": {
      maxWidth: '100%',
      padding: 10,
      borderRadius: 30,
      border: "unset",
      background: "unset",
      position: "relative",
      marginRight: 0,
      paddingLeft: 20,
      border: "1px solid #000",
      transition: "border 0.4s ease-in-out",
      "&:hover, &:focus": {
        boxShadow: "2px 2px 9px 2px rgba(0,0,0,0.1)",
      },
      [theme.breakpoints.up("md")]: {
        // width: 300,
      },
    },
    "& .MuiInputBase-root::before": {
      content: "unset",
    },
    "& .MuiInputBase-root::after": {
      content: "unset",
    },
    "& .MuiFormLabel-root": {
      paddingLeft: 10,
      color: "#AEB2BA",
      position: "relative",
      zIndex: 2,
      top: 20,
      left: 10,
    },
    "& .MuiFormLabel-root.Mui-focused": {
      paddingLeft: 10,
      color: theme.palette.primary.main,
      position: "relative",
      zIndex: 2,
      top: 0,
      left: 0,
    },
    "& .MuiFormLabel-root.MuiFormLabel-filled": {
      paddingLeft: 10,
      color: theme.palette.primary.main,
      position: "relative",
      zIndex: 2,
      top: 0,
      left: 0,
    },
    "& + *": {
      marginLeft: 16,
    },
  },
  customPraisoHeader: {
    display: "flex",
    alignItems: "flex-end",
    margin: theme.spacing(3, 0, .25),
  },
  headerTitle: {
    whiteSpace: "unset",
    // wordBreak: "break-all",
    wordWrap:"break-word",
    fontFamily: "Now",
    fontWeight: 700,
    fontSize: 20,
  },
  customPraisoHeaderTitle: {
    fontFamily: "Now",
    fontWeight: 700,
    marginBottom: "0.25em",
  },
  subTitle: {
    color: "rgb(175,179,187)",
    display: "block",
    fontSize: 12,
    marginTop: "4px",
  },
  markerContainer: {
    // position: 'absolute',
    // top: 0,
    // left: 0,
    // bottom: 0,
    // right: 0,
    width: "8px",
    height: "72px",
    margin: "-16px"
  },
  limitButton: {
    padding: "0.75em 1.1em",
    height: 51.94,
    marginBottom: theme.spacing(2),
  },
  groupByIcon: {
    marginRight: theme.spacing(1),
    cursor: 'pointer',
  },
  viewSelectorWrapper: {
    display: 'flex',
  },
  headerTitleWrapper: {
    flexGrow: 1
  },
  viewSelectorDropdown: {
    backgroundColor: '#fff',
    padding: theme.spacing(1.5, 3),
    display: 'flex',
    alignItems: 'center',
    width: 320,
    borderRadius: '10px 10px 0 0',
    cursor: 'pointer',
  },
  tableViewListPopover: {
    "& .MuiPaper-root": {
      width: 300
    }
  },
  tableViewList: {
    padding: "0"
  },
  tableViewListItem: {
    padding: theme.spacing(1, 2),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    minHeight: 64,
    "&:hover": {
      backgroundColor: "rgb(241, 242, 246)",
    },
  },
  tableViewListItemInner: {
    width: '100%',
  },
  tableViewListItemText: {
    // display: "inline-block", 
    // whiteSpace: "pre-line", 
    // position: "relative",
    // textOverflow: 'ellipsis',
    // wordWrap: "break-word",
    whiteSpace: "unset",
    wordBreak: "break-all",
    "& .MuiListItemText-primary": {
      fontSize: "14px",
      fontWeight: "500",
    }
  },
  customBadge: {
    // position: 'absolute',
    backgroundColor: theme.palette.primary.main,
    borderRadius: 10,
    color: theme.palette.primary.contrastText,
    fontSize: 12,
    padding: theme.spacing(.25, 1),
    // top: 0,
  },
  isSelected: {
    backgroundColor: 'rgba(241, 242, 246, 0.3)',
    cursor: 'default',
  },
  groupedCellWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  groupedCellLabel: {
    marginLeft: theme.spacing(2)
  },
  groupedCellLabelPrimary: {
    display: 'block',
    fontSize: 18,
    fontWeight: 500,
  },
  groupedCellLabelSecondary: {
    display: 'block',
    fontSize: 12,
    fontWeight: 400,
  },
  aggregatedCell: {
    fontSize: 16,
    fontWeight: 400,
  },
  userLink: {
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.87)",
  },
  paper: {
    position: 'absolute',
    width: '600px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '15px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    [theme.breakpoints.down("md")]: {
      width: '500px'
    },
    [theme.breakpoints.down("sm")]: {
      width: '375px',
    },
  },
  titlePopup: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: "#ssddff"
  },
  modal: {
    marginTop: '200px',
    display: 'flex',
    justifyContent: 'center',
  },
  reportEvent: {
    color: 'white',
    backgroundColor: '#ffac67',
    padding: '2px 12px',
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
    margin: "0px 0px 16px 0px",
    width: "fit-content",
    fontSize: "12px",
  },
  rejectEvent: {
    color: 'white',
    backgroundColor: '#D41D18',
    padding: '2px 12px',
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
    margin: "0px 0px 16px 0px",
    width: "fit-content",
    fontSize: "12px"
  },
  /* titleActionListItem: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgb(241, 242, 246)",
    },
  }, */
  titleActionListItem: {
    cursor: "pointer",
    padding: "16px 16px 16px 16px",
    "&:hover": {
      backgroundColor: "rgb(241, 242, 246)",
    },
  },
  titleActionListItemIcon: {
    marginLeft: "5px",
    display: "block"
  },
  titleActionListItemText: {
    "& .MuiListItemText-primary": {
      fontSize: "14px",
      fontWeight: 500,
    }
  },
  customDefaultBadge: {
    backgroundColor: "rgb(241, 242, 246)",
    borderRadius: 10,
    color: theme.palette.primary.contrastText,
    fontSize: 12,
    padding: theme.spacing(.25, 1),
  },
  titleActionContainer: {
    "& .MuiPopover-paper": {
      width: "300px"
    }
  },
  cellReported: {
    padding: "0px!important",
    "& .MuiBox-root": {
      padding: "0px 16px 16px 24px"
    },
  },
  createIcon: {
    margin: "12px"
  },
  approveContainer: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  titleActionList: {
    padding: "12px 24px 12px 10px"
  },
  actionButton: {
    backgroundColor: 'transparent!important'
  },
  autoGeneratedDiv: {
    display: 'flex'
  },
  autoGenerated: {
    height: '16px',
    width: '20px',
    marginRight: '2px',
    marginTop: '2px',
  },
  autoGeneratedText: {
    fontWeight: 300,
    color: "rgba(163, 171, 182)",
    fontSize: 12,
    marginLeft: '2px',
    marginTop: '2px',
  },
}));
